var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysAssistant = function SvgSysAssistant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.992 8.2a.85.85 0 1 1 1.7 0 .85.85 0 0 1-1.7 0ZM2.992 8.2a.85.85 0 1 1 1.7 0 .85.85 0 0 1-1.7 0ZM5.992 8.2a.85.85 0 1 1 1.7 0 .85.85 0 0 1-1.7 0Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.999 7.874 13 8c0 3.308-2.692 6-6 6h-.024a5.924 5.924 0 0 1-2.688-.647 1.466 1.466 0 0 0-.976-.123l-1.803.405.43-1.29c.149-.443.098-.938-.142-1.353A6.006 6.006 0 0 1 8.44 2.174c.163-.317.367-.61.605-.87A7 7 0 0 0 0 8a7.007 7.007 0 0 0 .931 3.493.658.658 0 0 1 .059.537l-.655 1.967c-.147.438.197.883.609.79l2.587-.582a.452.452 0 0 1 .307.041 7 7 0 0 0 10.143-6.77 3.975 3.975 0 0 1-.982.398Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4BAF4F",
    d: "M12 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  })));
};
export default SvgSysAssistant;